
import React from 'react';
import { XMarkIcon, PhoneIcon, MapPinIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const ContactPopup = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative overflow-hidden animate-slide-up">
                {/* Header Pattern */}
                <div className="h-24 bg-green-600 relative">
                    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-20"></div>
                    <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 bg-white p-2 rounded-full shadow-lg">
                        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center text-3xl">
                            👋
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
                    >
                        <XMarkIcon className="w-6 h-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="pt-12 pb-8 px-6 text-center">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                        Planning to start a project?
                    </h3>
                    <p className="text-gray-500 text-sm mb-6">
                        Get in touch with our experts for personalized agricultural solutions and consultancy.
                    </p>

                    <div className="space-y-4 text-left bg-gray-50 p-4 rounded-xl mb-6">
                        <div className="flex items-start gap-3">
                            <PhoneIcon className="w-5 h-5 text-green-600 mt-0.5" />
                            <div>
                                <p className="text-xs text-gray-400 font-medium">Call Us</p>
                                <p className="text-gray-800 font-medium">+91 7859837869</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <EnvelopeIcon className="w-5 h-5 text-green-600 mt-0.5" />
                            <div>
                                <p className="text-xs text-gray-400 font-medium">Email Us</p>
                                <p className="text-gray-800 font-medium">info@marvelousagri.com</p>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 py-2.5 text-gray-600 font-semibold text-sm hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            Later
                        </button>
                        <Link
                            to="/contact"
                            onClick={onClose}
                            className="flex-1 py-2.5 bg-green-600 text-white font-semibold text-sm rounded-lg hover:bg-green-700 transition-colors shadow-lg hover:shadow-green-500/30"
                        >
                            Contact Now
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPopup;
